<template src="./html/ProjectsMap.html"></template>

<script>
export default {
	props: ['user', 'isAuth', 'projects', 'project'],
	data () {
		return {
			modal: {
				selector: 'users-map',
			},
			map: {
				center: {
					lat: 0,
					lng: 0,
				},
				zoom: 10,
				markers: null,
			},
			infoContent: '',
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -25
				}
			},
		}
	},
	mounted() {
		if(this.$platform.place) {
			this.map.center.lat = parseFloat(this.$platform.place.lat)
			this.map.center.lng = parseFloat(this.$platform.place.lng)
		}

		var that = this
		$('#' + this.modal.selector).on('shown.bs.modal', function () {
			that.loadMarkers()
		})
	},
	watch: {
		'map.zoom'() {
			this.reZoom(this.map.zoom)
		},
	},
	methods: {
		open() {
			$('#' + this.modal.selector).modal('show');
		},
		close() {
			$('#' + this.modal.selector).modal('toggle');
		},
		loadMarkers() {
			if(this.projects) {
				var markers = []
				var that = this
				this.projects.forEach(function(project, key) {
					var places = project.places
					if(places) {
						places.forEach(function(place, key) {
							if(place.lat && place.lng) {
								var position = {
									id: place.id,
									position: {
										lat: parseFloat(place.lat),
										lng: parseFloat(place.lng),
									},
									infoText: {
										project: project,
										place: place,
									},
								}
								position = that.checkSameLocation(markers, position)
								markers.push(position)
							}
						})
					}
				})
				this.$set(this.map, 'markers', markers)
				if(markers.length) {
					this.fitBounds()
				}
			} else if(this.project) {
				if(this.project.places) {
					var markers = []
					var project = this.project
					var that = this
					this.project.places.forEach(function(place) {
						if(place.lat && place.lng) {
							var position = {
								id: place.id,
								position: {
									lat: parseFloat(place.lat),
									lng: parseFloat(place.lng),
								},
								infoText: {
									project: project,
									place: place,
								},
							}
							position = that.checkSameLocation(markers, position)
							markers.push(position)
						}
					})

					this.$set(this.map, 'markers', markers)
					if(markers.length) {
						this.fitBounds()
					}
				}
			}
		},
		toggleInfoWindow (marker, idx) {
			this.infoWindowPos = marker.position;
			this.infoContent = marker.infoText;
			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}
			//if different marker set infowindow to open and reset current marker index
			else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}
		},
		checkSameLocation(markers, position) {
			if(markers.length) {
				var found = markers.find(function(element, key) {
					return element.position.lat == position.position.lat && element.position.lng == position.position.lng
				})

				if(found) {
					position.position.lat = position.position.lat + (Math.random() -.5) / 1500;
					position.position.lng = position.position.lng + (Math.random() -.5) / 1500;
				}
			}

			return position
		},
		fitBounds() {
			this.infoWinOpen = false
			if(this.map.markers.length) {
				var b = new google.maps.LatLngBounds()
				this.map.markers.forEach(function(element) {
					b.extend({
						lat: element.position.lat,
						lng: element.position.lng,
					});
				})
				this.$refs.gmapMap.fitBounds(b)
				if(this.map.markers.length == 1) {
					this.map.zoom = 12
				}
			}
		},
		reZoom() {
			this.$refs.gmapMap.$mapObject.setZoom(this.map.zoom)
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/ProjectsMap.vue